console.log("cargó nervsoft");
//alert(":)");
//console.log("Hi joel soy JS inyectado");

const hero_off=document.getElementById("Hero-template--21112030101593__hero_nMzDpq");

var img_banner_hero=null;
if(hero_off!=null){
    const hero_wrapper=hero_off.querySelectorAll('.hero__media-wrapper')[0];

    hero_wrapper.style.display="block";

    img_banner_hero=hero_wrapper.querySelectorAll('img');    
}


const og_url_arr=document.querySelectorAll('meta[property="og:url"]'); 
//alert(og_url_arr);

if(og_url_arr.length>0){
    og_url=og_url_arr[0].content;
    console.log(og_url);

    if(img_banner_hero!=null){
        if(img_banner_hero.length>1){
            //alert("XD");
            if(og_url.includes("/en")){
                //alert(":)");
                img_banner_hero[0].style.display="none";
                img_banner_hero[1].style.display="block";
            }else{
                //alert(":(");
                img_banner_hero[0].style.display="block";
                img_banner_hero[1].style.display="none";
            }        
        }
    }





    if(og_url.includes("/products/")){
        console.log("estoy viendo un producto");
        var og_img="";
        const og_img_arr=document.querySelectorAll('meta[property="og:image"]'); 
        if(og_img_arr.length>0){
            og_img=og_img_arr[0].content;
        }

        var og_title="";
        const og_title_arr=document.querySelectorAll('meta[property="og:title"]'); 
        if(og_title_arr.length>0){
            og_title=og_title_arr[0].content;
        }

        console.log(og_img);
        console.log(og_title);

        const obj_viewed={url:og_url,img:og_img,title:og_title};
        console.log(obj_viewed);


        if(localStorage.hasOwnProperty('recent_viewed')){
            //var recent_viewed=localStorage.getItem("recent_viewed");
            var recent_viewed=JSON.parse(localStorage["recent_viewed"]);
            if(recent_viewed.length>10){
                recent_viewed.shift();
            }
            var flag_repetido=false;
            recent_viewed.forEach((viewed) => {
                //alert(viewed);
                og_url=og_url.replace("en/products","products");
                if(viewed.url==og_url){
                    flag_repetido=true;
                }
            });


            recent_viewed.push(obj_viewed);
            console.log(recent_viewed);

            if(flag_repetido==false){
                localStorage.setItem("recent_viewed", JSON.stringify(recent_viewed));
            }
            
        }else{
            var recent_viewed=[];
            recent_viewed.push(obj_viewed);
            console.log(recent_viewed);
            localStorage.setItem("recent_viewed", JSON.stringify(recent_viewed));
        }       


    }else{
        console.log("NO estoy viendo un producto");
        const div_recent_block=document.getElementById("shopify-section-template--21112030101593__section_jaHHER");
        const div_recent_viewed=document.querySelectorAll("#div_recent_viewed")[0];
        div_recent_viewed.style.display = "none";
        div_recent_block.style.display = "none";
        if(localStorage.hasOwnProperty('recent_viewed')){
            //var recent_viewed=localStorage.getItem("recent_viewed");
            var recent_viewed=JSON.parse(localStorage["recent_viewed"]);
            
            recent_viewed = recent_viewed.reverse();
           
        
            if(recent_viewed.length>0){
                div_recent_viewed.style.display = "block";
                div_recent_block.style.display = "block";
            }
            if(recent_viewed.length>5){
                const div_slideshow_arrows_next=document.querySelectorAll("#div_recent_viewed slideshow-arrows button.slideshow-control--next")[0];
                div_slideshow_arrows_next.removeAttribute("disabled");
            }
            

            if(recent_viewed.length>10){

            }
            
            const slideshow_slides=document.querySelectorAll(".productos slideshow-slides")[0];
            var div_product_base=document.querySelectorAll('.productos slideshow-slide')[0].cloneNode(true);
            console.log(div_product_base);
            document.querySelectorAll('.productos slideshow-slide')[0].remove();

            var i=0;
            recent_viewed.forEach((viewed) => {
                console.log(viewed);
                console.log(viewed.url);
                console.log(viewed.img);
                var div_product=div_product_base.cloneNode(true);
                var enlaces=div_product.querySelectorAll("a");

                div_product.setAttribute("style","view-timeline-name: --slide-"+i+"; --product-media-fit: cover;");
                if(enlaces.length>0){
                    enlaces.forEach((enlace) => {
                        enlace.setAttribute("href",viewed.url);
                    });
                }
                var imagenes=div_product.querySelectorAll("img");
                if(imagenes.length>0){
                    var i_i=0;
                    imagenes.forEach((imagen) => {
                        console.log(imagen)
                        imagen.setAttribute("src",viewed.img);
                        i_i++;
                    });
                }

                /*slideshow_slides.append(div_product);*/
                /*div_product.insertAdjacentHTML('afterend',slideshow_slides)*/
                slideshow_slides.appendChild(div_product);
                i++;
            });
        }
    }
}
